import React, { useMemo, useReducer } from 'react';
import { registerReducer } from './registerReducer';
import { RegisterContext } from './useRegister';

type RegisterProviderProps = {
  phoneNumber: string;
  children: React.ReactNode;
};

export const RegisterProvider = (props: RegisterProviderProps) => {
  const [state, dispatch] = useReducer(registerReducer, {
    data: { type: 'HEALTH_AUTH', phoneNumber: props.phoneNumber },
    loading: false,
  });
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <RegisterContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </RegisterContext.Provider>
  );
};
